import React, { useEffect, useRef, useState } from "react";
import ManageJP from "./ManageJP";
import MainTabSection from "./MainTabSection";
import Filters from "./filters";
import Pagination from "./common/Pagination/Pagination";
import { useLazyGetJobsQuery } from "../redux/apis/manageJobPostingHooks";
import { handleFilterParamsTypes } from "../types/custom-types";
import { LANDING_PAGE_OR_DEFAULT_JOBTYPE } from "../constants/Filters";
// import { foundit_beamer } from "@foundit/beamer";
import { capitalizeFirstLetters } from "../utils";

const Home = () => {
  const [active, setActive] = useState("Active");
  const search = window.location.search; // returns the URL query String
  const params = new URLSearchParams(search); 
  const filter = params.get('filter');
  const [filterParams, setFilterParams] = useState<handleFilterParamsTypes>({
    startDate: "",
    endDate: "",
    jobTypeFilter: LANDING_PAGE_OR_DEFAULT_JOBTYPE,
    jobStatus: active === 'Inbound_Jobs' ? "ACTIVE" :  active?.toUpperCase(),
    searchKeyword: "",
    inbound: active === 'Inbound_Jobs',
    page: 1,
    limit: 6,
  });
  const isFirstRender = useRef<boolean>(true);

  const handleFilterParams = (
    filterObjects: {
      startDate?: string | null;
      endDate?: string | null;
      jobTypeFilter?: string | number;
      searchKeyword?: string | null;
    } | null
  ) => {
    let isInbound = active === 'Inbound_Jobs';
    setFilterParams((prev) => ({
      ...prev,
      ...filterObjects,
      jobTypeFilter:
        filterObjects?.jobTypeFilter || LANDING_PAGE_OR_DEFAULT_JOBTYPE,
      jobStatus: isInbound ? "ACTIVE" : active?.toUpperCase(),
      inbound: isInbound,
    }));
  };

  const handleSetActive = (label: string) => {
    let isInbound = label === 'Inbound_Jobs';
    if(filter && !isInbound){
      window.history.pushState({}, '', `/edge/managejobposting`);
    }
    setActive(label);
    setFilterParams((prev) => ({
      ...prev,
      jobStatus: isInbound ? "ACTIVE" : label?.toUpperCase(),
      inbound: isInbound,
      page: 1,
    }));
  };

  const [triggerGetJobs, { isError, data, isFetching, isSuccess }] = useLazyGetJobsQuery();

  const beamer_config = {
    product_id: "eygKEHYD58996", //DO NOT CHANGE: This is your product code on Beamer
    display: "popup",
    bottom: 80,
    right: 32,
    /* user_id: '1234',
    user_email: 'john@getbeamer.com',
    user_firstname: 'John',
    user_lastname: 'Doe',
    company_name: 'John Doe Co.', // Custom user attribute
    signed_up_at: '2019-01-30T00:00:00Z', // Custom user attribute
    paid_account: true, // Custom user attribute
    posts_created: 120 // Custom user attribute */
  };
  const timedelay = 5000; // miliseconds

  // foundit_beamer.init(beamer_config, timedelay);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("tab")) {
      let setInitialTab = urlParams.get("tab");
      setInitialTab = capitalizeFirstLetters(
        setInitialTab?.toLowerCase() || "Active"
      );
      handleSetActive(setInitialTab);
      urlParams.delete("tab");
    }
  }, []);

  useEffect(() => {
  if(filter){
    handleSetActive(filter);
  } 
}, [filter]);
  

  useEffect(() => {
    const params: { [key: string]: any } = {};

    for (const key in filterParams) {
      // Check if the value is truthy (not null or empty string)
      if (filterParams[key as keyof handleFilterParamsTypes]) {
        // Add the key-value pair to params
        params[key] = filterParams[key as keyof handleFilterParamsTypes];
      }
    }

    //Account for social jobs edge case.
    if (params.jobTypeFilter == "SOCIAL") {
      params.jobTypeFilter = "ALL";
      params["socialJob"] = true;
    } else {
      params["socialJob"] = false;
    }

    triggerGetJobs(params);
  }, [triggerGetJobs, filterParams]);

useEffect(() => {
  if (isSuccess) {
    let jobId = params.get("jobId");
    if (jobId && filterParams.searchKeyword === "") {
      setFilterParams((prev) => {
        return { ...prev, searchKeyword: jobId };
      });
    }

    if (!data || !isFirstRender?.current) return;

    if (data.jobs?.length === 0) {
      const statusCount = data?.jobStatusCount;

      let updatedStatus = filterParams.jobStatus;
      let inboundValue: any = undefined;
      let label: string = "Active";

      if (statusCount?.expired > 0) {
        updatedStatus = "EXPIRED";
        label = "Expired";
      } else if (statusCount?.active > 0) {
        updatedStatus = "ACTIVE";
        label = "Active";
      } else if (statusCount?.inbound > 0) {
        updatedStatus = "ACTIVE";
        label = "Inbound_Jobs";
        inboundValue = true;
      } else if (statusCount?.scheduled > 0) {
        updatedStatus = "SCHEDULED";
        label = "Scheduled";
      } else if (statusCount?.drafts > 0) {
        updatedStatus = "DRAFTS";
        label = "Drafts";
      }
      setActive(label);

      setFilterParams((prev) => ({
        ...prev,
        jobStatus: updatedStatus,
        ...(inboundValue ? { inbound: true } : {}),
        page: 1,
      }));
    }
    isFirstRender.current = false;
  }
}, [params, data?.jobStatusCount, isSuccess]);


  return (
    <div className="mjp_page-container">
      <div className="mjp_page-left">
        <div className="mjp_page-left-sticky-filters">
          <Filters
            activeTab={active}
            urlParams={filterParams}
            setURLParams={handleFilterParams}
            setActiveTab={setActive}
          />
        </div>
      </div>
      <div className="mjp_page-right">
        <MainTabSection
          active={active}
          setActive={handleSetActive}
          jobStatusCount={data?.jobStatusCount}
          showInboundTab={data?.showInboundTab}
        />
        <ManageJP
          active={active}
          setActive={setActive}
          jobsData={data?.jobs || [{}]}
          isFetching={isFetching}
          isFetchError={isError}
          setFilterParams={setFilterParams}
        />

        {!isError && data?.jobs?.length > 0 ? (
          <div className="float-right">
            <Pagination
              pageLimit={filterParams.limit}
              totalRows={data?.jobStatusCount?.[active === 'Inbound_Jobs' ? "inbound" : active?.toLowerCase()]}
              onPageChange={(page: number) =>
                setFilterParams((prev) => ({
                  ...prev,
                  page: page,
                }))
              }
              maxPageNumsInView={6}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Home;
